const red = {
    100: 'rgb(235, 173, 174)',
    200: 'rgb(226, 141, 142)',
    300: 'rgb(218, 108, 110)',
    400: 'rgb(210, 75, 78)',
    500: 'rgb(196, 49, 51)',
    600: 'rgb(163, 41, 43)',
    700: 'rgb(131, 33, 34)',
    800: 'rgb(98, 24, 26)',
};
export default red;
